import { atom } from 'jotai';
import { DEFAULT_PAGINATION } from '@/common/pagination/types.ts';

export const clientPaginationAtom = atom(DEFAULT_PAGINATION);

export const resetClientPaginationOnFilterChangeAtom = atom(null, (_get, set) => {
  set(clientPaginationAtom, DEFAULT_PAGINATION);
});
